export const SET_PLATFORMS = 'SET_PLATFORMS';
export const SET_DOMAINS = 'SET_DOMAINS';
export const SET_AGENCIES = 'SET_AGENCIES';
export const SET_ENTITIES = 'SET_ENTITIES';
export const SET_PLATFORM = 'SET_PLATFORM';
export const SET_NAME = 'SET_NAME';
export const SET_URL = 'SET_URL';
export const SET_PLATORM_CALLS = 'SET_PLATORM_CALLS';
export const SET_PLATFORM_RENAWAL_PERIOD = 'SET_PLATFORM_RENAWAL_PERIOD';
